/**
 * Section: Perle Lactée
 * - Clic sur miniature → change l'image principale
 * - Accordéons : ouverture / fermeture
 */

(function () {
  'use strict';

  function parseMoney(value) {
    if (value === null || value === undefined) return 0;
    var str = String(value);
    // Exemple: "+80€", "352 € TTC", "67,00€"
    var match = str.replace(/\s/g, '').match(/[-+]?\d+(?:[.,]\d+)?/);
    if (!match) return 0;
    var normalized = match[0].replace(',', '.');
    var num = parseFloat(normalized);
    return isNaN(num) ? 0 : num;
  }

  function formatAmount(num) {
    if (typeof num !== 'number' || isNaN(num)) return '0';
    var isInt = Math.round(num) === num;
    if (isInt) return String(num);
    // Format FR simple : 2 décimales, virgule
    return num.toFixed(2).replace('.', ',');
  }

  /** Montant calculé + suffixe (ex. € TTC) avec espace : « 350 € » et non « 350€ » */
  function joinFormattedAmountAndSuffix(formatted, rawSuffix) {
    var t = String(rawSuffix || '').trim();
    if (!t) return formatted;
    return formatted + ' ' + t;
  }

  function plPostJsonJsConfig() {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
    };
  }

  function collectPerleLineProperties(container) {
    var props = {};
    var postal = container.querySelector('[data-delivery-postal]');
    if (postal && postal.value) {
      var pVal = postal.value.trim();
      if (pVal) props['Code postal ou ville'] = pVal;
    }
    var hid = container.querySelector('[data-perle-delivery-panel] [data-delivery-date]');
    if (!hid) hid = container.querySelector('[data-delivery-date]');
    if (hid && hid.value) {
      var dRaw = hid.value.trim();
      if (dRaw) {
        try {
          var dt = new Date(dRaw + 'T12:00:00');
          props['Date de livraison'] = !isNaN(dt.getTime())
            ? dt.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })
            : dRaw;
        } catch (_e) {
          props['Date de livraison'] = dRaw;
        }
      }
    }
    var flowerTitles = [];
    container
      .querySelectorAll('.romance-pure__option-card.is-selected[data-kit-option="flower"]')
      .forEach(function (fl) {
        var ft = fl.querySelector('.romance-pure__option-title');
        if (ft) {
          var ftx = ft.textContent.trim();
          if (ftx) flowerTitles.push(ftx);
        }
      });
    if (flowerTitles.length) props['Pack fleurs'] = flowerTitles.join(', ');
    var materialTitles = [];
    container
      .querySelectorAll('.romance-pure__option-card.is-selected[data-kit-option="material"]')
      .forEach(function (mt) {
        var mtEl = mt.querySelector('.romance-pure__option-title');
        if (mtEl) {
          var mtx = mtEl.textContent.trim();
          if (mtx) materialTitles.push(mtx);
        }
      });
    if (materialTitles.length) props['Matériel'] = materialTitles.join(', ');
    var sz = container.querySelector('.romance-pure__size-option.is-selected');
    if (sz && sz.dataset.sizeLabel) {
      var slab = sz.dataset.sizeLabel.trim();
      if (slab) props['Taille pack'] = slab;
    }
    return props;
  }

  function perleResolveVariantId(container) {
    var vid = '';
    var sel = container.querySelector('.romance-pure__size-option.is-selected');
    if (sel && sel.dataset && sel.dataset.variantId) vid = String(sel.dataset.variantId).trim();

    if (!vid) {
      var any = container.querySelector('.romance-pure__size-option[data-variant-id]');
      if (any && any.dataset && any.dataset.variantId) vid = String(any.dataset.variantId).trim();
    }
    if (!vid && container.dataset && container.dataset.perleDefaultVariant)
      vid = String(container.dataset.perleDefaultVariant).trim();

    vid = vid.replace(/\s/g, '');
    if (!/^\d+$/.test(vid)) return '';
    return vid;
  }

  function extractHandleFromOptionLink(rawUrl) {
    var u = String(rawUrl || '').trim();
    if (!u) return '';
    try {
      var parsed = new URL(u, window.location.origin);
      var m = parsed.pathname.match(/\/products\/([^/?#]+)/i);
      return m && m[1] ? m[1] : '';
    } catch (_e) {
      var mm = u.match(/\/products\/([^/?#]+)/i);
      return mm && mm[1] ? mm[1] : '';
    }
  }

  function fetchProductJson(productHandle) {
    if (!productHandle) return Promise.resolve(null);
    var origin = window.location.origin || '';
    var url = origin + '/products/' + productHandle + '.js';
    return fetch(url)
      .then(function (r) {
        return r.ok ? r.json() : Promise.reject(new Error('product not found'));
      })
      .then(function (product) {
        return product || null;
      })
      .catch(function () {
        return null;
      });
  }

  function fetchFirstVariantId(productHandle) {
    return fetchProductJson(productHandle).then(function (product) {
      if (!product || !product.variants || !product.variants.length) return null;
      var v =
        product.variants.find(function (x) {
          return x && x.available;
        }) || product.variants[0];
      return v && v.id ? v.id : null;
    });
  }

  function getAddonProductHandle(btn) {
    if (!btn) return '';
    var explicit = (btn.getAttribute('data-product-handle') || '').trim();
    if (explicit) return explicit;
    return extractHandleFromOptionLink(btn.getAttribute('data-option-link') || '');
  }

  function addonCardSupportsQty(btn) {
    return !!getAddonProductHandle(btn);
  }

  function getAddonLineQty(btn, qtyInputAttr) {
    if (!btn) return 1;
    if (!addonCardSupportsQty(btn)) return 1;
    var input = btn.querySelector('[' + qtyInputAttr + ']');
    var q = input ? parseInt(input.value, 10) : 1;
    if (isNaN(q) || q < 1) q = 1;
    return q;
  }

  function getAddonLineUnitPrice(btn) {
    if (!btn) return 0;
    return parseMoney(btn.dataset.optionIncrement);
  }

  function resolveAddonCartEntries(buttons, qtyInputAttr) {
    var entries = [];
    buttons.forEach(function (btn) {
      var handle = getAddonProductHandle(btn);
      if (!handle) return;
      entries.push({
        handle: handle,
        variantId: null,
        quantity: getAddonLineQty(btn, qtyInputAttr),
      });
    });
    return entries;
  }

  function resolveCartAddonItems(container) {
    var flowerButtons = container.querySelectorAll(
      '.romance-pure__option-card[data-kit-option="flower"][data-option-increment].is-selected'
    );
    var materialButtons = container.querySelectorAll(
      '.romance-pure__option-card[data-kit-option="material"][data-option-increment].is-selected'
    );
    var entries = resolveAddonCartEntries(flowerButtons, 'data-flower-qty-input').concat(
      resolveAddonCartEntries(materialButtons, 'data-material-qty-input')
    );
    if (!entries.length) return Promise.resolve([]);

    return Promise.all(
      entries.map(function (entry) {
        if (entry.variantId) return Promise.resolve(entry);
        return fetchFirstVariantId(entry.handle).then(function (variantId) {
          entry.variantId = variantId ? Number(variantId) : null;
          return entry;
        });
      })
    ).then(function (resolvedEntries) {
      return resolvedEntries
        .filter(function (entry) {
          return entry && entry.variantId;
        })
        .map(function (entry) {
          return { id: Number(entry.variantId), quantity: entry.quantity || 1 };
        });
    });
  }

  function wirePerleLacteeAddToCart(container, addToCartBtn) {
    if (!addToCartBtn || addToCartBtn.dataset.blancCartBound === '1') return;
    addToCartBtn.dataset.blancCartBound = '1';

    addToCartBtn.addEventListener('click', function () {
      if (
        addToCartBtn.classList.contains('loading') ||
        addToCartBtn.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }
      var vid = perleResolveVariantId(container);
      if (!vid) {
        window.alert(
          'Variante introuvable : dans l’éditeur de thème, section Perle Lactée, choisissez « Produit pour le panier » et alignez les libellés des blocs taille avec les options du produit ; ou renseignez l’« ID variante » sur chaque bloc taille.'
        );
        return;
      }
      var variantNum = Number(vid, 10);
      var props = collectPerleLineProperties(container);

      var cartBubble = document.querySelector('cart-dropdown-bubble');
      var routesObj = typeof window.routes !== 'undefined' && window.routes ? window.routes : {};
      var cartUrl = routesObj.cart_add_url || '/cart/add.js';

      var item = {
        id: variantNum,
        quantity: 1,
      };
      var pKeys = Object.keys(props || {});
      if (pKeys.length > 0) item.properties = props;

      addToCartBtn.classList.add('loading');
      addToCartBtn.setAttribute('aria-disabled', 'true');

      var cfg = plPostJsonJsConfig();
      cfg.headers['X-Requested-With'] = 'XMLHttpRequest';

      resolveCartAddonItems(container)
        .then(function (addonItems) {
          var allItems = [item];
          if (addonItems && addonItems.length) {
            addonItems.forEach(function (addon) {
              if (!addon || !addon.id || addon.id === item.id) return;
              allItems.push(addon);
            });
          }

          var formQuantity = {};
          allItems.forEach(function (line) {
            formQuantity[line.id] = (formQuantity[line.id] || 0) + (line.quantity || 1);
          });

          var bodyObj = { items: allItems };
          if (cartBubble && typeof cartBubble.getSectionsToRender === 'function') {
            try {
              bodyObj.sections = cartBubble.getSectionsToRender().map(function (s) {
                return s.id;
              });
              bodyObj.sections_url = window.location.pathname;
            } catch (_outer) {}
          }

          cfg.body = JSON.stringify(bodyObj);
          return fetch(cartUrl, cfg).then(function (r) {
            return r.json();
          }).then(function (response) {
            if (response.status) {
              var msg = response.description || response.message || 'Impossible d’ajouter au panier.';
              if (cartBubble && typeof cartBubble.renderError === 'function') cartBubble.renderError(msg);
              else window.alert(msg);
              return;
            }
            response.quantityItem = formQuantity;
            if (cartBubble && typeof cartBubble.renderContents === 'function')
              cartBubble.renderContents(response);
          });
        })
        .then(function (r) {
          return r;
        })
        .catch(function (err) {
          console.error(err);
          window.alert('Une erreur est survenue lors de l’ajout au panier.');
        })
        .finally(function () {
          addToCartBtn.classList.remove('loading');
          addToCartBtn.removeAttribute('aria-disabled');
          try {
            if (
              typeof window.cartAjax !== 'undefined' &&
              window.cartAjax &&
              typeof openCartModal === 'function'
            ) {
              openCartModal();
            } else if (routesObj.cart_url) window.location.href = routesObj.cart_url;
            else window.location.href = '/cart';
          } catch (_e2) {}
        });
    });
  }


  function setupMobileStickyCart(container, buttonWrap, originalButton) {
    if (!container || !buttonWrap || !originalButton || buttonWrap.dataset.stickyCartBound === '1') return null;
    buttonWrap.dataset.stickyCartBound = '1';

    var stickyWrap = buttonWrap.cloneNode(true);
    stickyWrap.classList.add('romance-pure__sticky-button-wrap');
    stickyWrap.classList.remove('is-visible');
    stickyWrap.setAttribute('aria-hidden', 'true');
    stickyWrap.removeAttribute('data-sticky-cart-bound');

    var stickyWishlist = stickyWrap.querySelector('.romance-pure__wishlist-button');
    if (stickyWishlist) stickyWishlist.remove();

    var stickyButton = stickyWrap.querySelector('[data-fleurs-add-to-cart]') || stickyWrap.querySelector('[data-perle-add-to-cart]') || stickyWrap.querySelector('.romance-pure__button');
    if (stickyButton) {
      stickyButton.removeAttribute('data-fleurs-add-to-cart');
      stickyButton.removeAttribute('data-perle-add-to-cart');
      stickyButton.removeAttribute('data-fleurs-cart-bound');
      stickyButton.addEventListener('click', function () {
        originalButton.click();
      });
    }

    var originalQtyInput = container.querySelector('[data-qty-input]');
    if (stickyButton && originalQtyInput) {
      var stickyQty = document.createElement('div');
      stickyQty.className = 'romance-pure__sticky-qty';

      var stickyMinus = document.createElement('button');
      stickyMinus.type = 'button';
      stickyMinus.className = 'romance-pure__sticky-qty-btn';
      stickyMinus.setAttribute('aria-label', 'Diminuer la quantite');
      stickyMinus.textContent = '-';

      var stickyQtyValue = document.createElement('span');
      stickyQtyValue.className = 'romance-pure__sticky-qty-value';
      stickyQtyValue.setAttribute('aria-live', 'polite');

      var stickyPlus = document.createElement('button');
      stickyPlus.type = 'button';
      stickyPlus.className = 'romance-pure__sticky-qty-btn';
      stickyPlus.setAttribute('aria-label', 'Augmenter la quantite');
      stickyPlus.textContent = '+';

      function clampStickyQty(value) {
        var min = parseInt(originalQtyInput.getAttribute('min'), 10) || 1;
        var max = parseInt(originalQtyInput.getAttribute('max'), 10) || 99;
        var qty = parseInt(value, 10);
        if (isNaN(qty)) qty = min;
        if (qty < min) qty = min;
        if (qty > max) qty = max;
        return qty;
      }

      function syncStickyQty() {
        stickyQtyValue.textContent = String(clampStickyQty(originalQtyInput.value));
      }

      function setOriginalQty(value) {
        originalQtyInput.value = String(clampStickyQty(value));
        originalQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        syncStickyQty();
      }

      stickyMinus.addEventListener('click', function () {
        setOriginalQty((parseInt(originalQtyInput.value, 10) || 1) - 1);
      });
      stickyPlus.addEventListener('click', function () {
        setOriginalQty((parseInt(originalQtyInput.value, 10) || 1) + 1);
      });
      originalQtyInput.addEventListener('change', syncStickyQty);
      originalQtyInput.addEventListener('input', syncStickyQty);
      originalQtyInput.addEventListener('blur', syncStickyQty);

      stickyQty.appendChild(stickyMinus);
      stickyQty.appendChild(stickyQtyValue);
      stickyQty.appendChild(stickyPlus);
      stickyWrap.insertBefore(stickyQty, stickyButton);
      syncStickyQty();
    }

    document.body.appendChild(stickyWrap);

    var mobileQuery = window.matchMedia('(max-width: 767px)');

    function setStickyVisible(visible) {
      var shouldShow = visible && mobileQuery.matches;
      stickyWrap.classList.toggle('is-visible', shouldShow);
      stickyWrap.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function originalButtonVisible() {
      var rect = buttonWrap.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.bottom > 0 && rect.top < viewportHeight;
    }

    function updateStickyState() {
      setStickyVisible(!originalButtonVisible());
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setStickyVisible(!(entry && entry.isIntersecting));
      }, { threshold: 0.01 });
      observer.observe(buttonWrap);
    } else {
      window.addEventListener('scroll', updateStickyState, { passive: true });
    }

    window.addEventListener('resize', updateStickyState);
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', updateStickyState);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(updateStickyState);
    }

    updateStickyState();
    return stickyButton;
  }

  function initPerleLactee(container) {
    if (!container) return;

    function syncAccordionsToSelectedSize() {
      var accordions = container.querySelectorAll('.romance-pure__accordion');
      var sizeBtns = container.querySelectorAll('.romance-pure__size-option[data-size-total]');
      if (!accordions.length) return;
      if (!sizeBtns.length) {
        accordions.forEach(function (acc) {
          acc.hidden = false;
        });
        return;
      }
      var selected = container.querySelector('.romance-pure__size-option.is-selected');
      var label =
        selected && selected.dataset.sizeLabel != null ? String(selected.dataset.sizeLabel).trim() : '';
      accordions.forEach(function (acc) {
        var forSize = (acc.getAttribute('data-accordion-for-size') || '').trim();
        var show = !forSize || forSize.toLowerCase() === label.toLowerCase();
        acc.hidden = !show;
        if (!show) {
          acc.classList.remove('is-open');
          var tg = acc.querySelector('[data-accordion-toggle]');
          if (tg) tg.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Galerie : clic sur une miniature pour mettre à jour l'image principale
    var mainImageWrapper = container.querySelector('.romance-pure__main-image');
    var mainImg = container.querySelector('.romance-pure__main-image img');
    var thumbs = container.querySelectorAll('.romance-pure__thumb');

    // Carrousel miniatures (flèches + scroll horizontal)
    var thumbCarousel = container.querySelector('.romance-pure__thumb-carousel');
    var thumbViewport = container.querySelector('.romance-pure__thumbnails');
    var prevBtn = container.querySelector('.romance-pure__thumb-prev');
    var nextBtn = container.querySelector('.romance-pure__thumb-next');

    if (thumbCarousel && thumbViewport && prevBtn && nextBtn) {
      var thumbStyles = window.getComputedStyle(thumbViewport);
      var thumbGap = thumbStyles.columnGap && thumbStyles.columnGap !== 'normal' ? thumbStyles.columnGap : '12px';
      var thumbTrack = document.createElement('div');
      thumbTrack.className = 'fe-thumb-track';
      thumbTrack.style.display = 'flex';
      thumbTrack.style.flexWrap = 'nowrap';
      thumbTrack.style.alignItems = 'center';
      thumbTrack.style.gap = thumbGap;
      thumbTrack.style.width = 'max-content';
      thumbTrack.style.minWidth = 'max-content';
      thumbTrack.style.flex = '0 0 auto';
      thumbTrack.style.transform = 'translateX(0px)';
      while (thumbViewport.firstChild) thumbTrack.appendChild(thumbViewport.firstChild);
      thumbViewport.appendChild(thumbTrack);

      thumbViewport.style.overflow = 'hidden';
      thumbViewport.style.minWidth = '0';
      thumbViewport.style.flex = '1 1 auto';
      thumbViewport.style.scrollSnapType = 'none';
      thumbViewport.style.justifyContent = 'flex-start';

      var thumbOffset = 0;

      var maxThumbOffset = function () {
        var trackWidth = Math.max(thumbTrack.scrollWidth, Math.round(thumbTrack.getBoundingClientRect().width));
        return Math.max(0, trackWidth - thumbViewport.clientWidth);
      };

      var applyThumbOffset = function () {
        var maxOffset = maxThumbOffset();
        if (thumbOffset < 0) thumbOffset = 0;
        if (thumbOffset > maxOffset) thumbOffset = maxOffset;
        thumbTrack.style.transform = 'translateX(' + (-Math.round(thumbOffset)) + 'px)';
        var atStart = thumbOffset <= 1;
        var atEnd = thumbOffset >= maxOffset - 1;
        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;
        prevBtn.style.opacity = atStart ? '0.35' : '1';
        nextBtn.style.opacity = atEnd ? '0.35' : '1';
        prevBtn.style.cursor = atStart ? 'default' : 'pointer';
        nextBtn.style.cursor = atEnd ? 'default' : 'pointer';
      };

      var syncThumbViewportWidth = function () {
        var arrows = (prevBtn.offsetWidth || 0) + (nextBtn.offsetWidth || 0);
        var carouselStyles = window.getComputedStyle(thumbCarousel);
        var gap = parseFloat(carouselStyles.columnGap || carouselStyles.gap) || 0;
        var available = thumbCarousel.clientWidth - arrows - (gap * 2);
        if (mainImageWrapper) {
          var imageWidth = mainImageWrapper.getBoundingClientRect().width;
          if (imageWidth > 0) available = available > 0 ? Math.min(available, imageWidth) : imageWidth;
        }
        if (available > 40) {
          thumbViewport.style.maxWidth = Math.round(available) + 'px';
          thumbViewport.style.width = Math.round(available) + 'px';
        }
        applyThumbOffset();
      };

      var step = function () {
        return Math.max(40, Math.round(thumbViewport.clientWidth * 0.7));
      };

      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (prevBtn.disabled) return;
        thumbOffset -= step();
        applyThumbOffset();
      });
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (nextBtn.disabled) return;
        thumbOffset += step();
        applyThumbOffset();
      });

      window.addEventListener('resize', syncThumbViewportWidth);
      window.addEventListener('load', syncThumbViewportWidth);
      syncThumbViewportWidth();
    }

    // Sélection par défaut (première miniature) si aucune n'est active
    if (thumbs && thumbs.length > 0) {
      var anyActive = false;
      thumbs.forEach(function (t) {
        if (t.classList.contains('is-active')) anyActive = true;
      });
      if (!anyActive) {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumbs[0].classList.add('is-active');
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = thumb.querySelector('img');
        if (img && mainImg) {
          // Utiliser directement l'URL HD prévue côté Liquid (évite les regex qui ne matchent pas toujours)
          var largeSrc = img.dataset.largeSrc;
          if (largeSrc) {
            mainImg.setAttribute('src', largeSrc);
            mainImg.setAttribute('data-lightbox-src', largeSrc);
          } else {
            var src = img.getAttribute('src');
            if (src) {
              mainImg.setAttribute('src', src);
              mainImg.setAttribute('data-lightbox-src', src);
            }
          }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        }
      });
    });

    // Accordéons : un seul ouvert à la fois
    var toggles = container.querySelectorAll('.romance-pure__accordion-toggle');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var accordion = toggle.closest('.romance-pure__accordion');
        if (!accordion) return;
        var group = accordion.parentElement;
        var willOpen = !accordion.classList.contains('is-open');
        if (group) {
          group.querySelectorAll('.romance-pure__accordion-toggle').forEach(function (otherToggle) {
            var other = otherToggle.closest('.romance-pure__accordion');
            if (!other || other === accordion) return;
            other.classList.remove('is-open');
            otherToggle.setAttribute('aria-expanded', 'false');
          });
        }
        accordion.classList.toggle('is-open', willOpen);
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    // Fleurs / matériel : « Voir tous » → affiche le reste des options (grille normale)
    container.querySelectorAll('[data-kit-view-all]').forEach(function (btn) {
      if (btn.dataset.kitExpandBound === '1') return;
      var kind = btn.getAttribute('data-kit-view-all');
      if (!kind) return;
      var wrap = btn.closest('.romance-pure__option-cards');
      if (!wrap) return;
      var primary = wrap.querySelector('.romance-pure__option-cards-primary');
      var extra = wrap.querySelector('[data-kit-extra="' + kind + '"]');
      if (!extra) return;
      var extraInner = extra.querySelector('.romance-pure__option-cards-extra-inner');
      if (!primary || !extraInner) return;
      btn.dataset.kitExpandBound = '1';
      if (!btn.dataset.kitViewAllLabel) {
        btn.dataset.kitViewAllLabel = btn.textContent.trim();
      }
      var openLabel = btn.dataset.kitViewAllLabel;
      var closeLabel = btn.getAttribute('data-kit-view-less') || 'Voir moins';

      btn.addEventListener('click', function () {
        var show = extra.hidden;
        if (show) {
          extra.hidden = false;
          // Ouvert: le bouton devient le dernier item du bloc des options visibles.
          extraInner.appendChild(btn);
          btn.setAttribute('aria-expanded', 'true');
          btn.textContent = closeLabel;
        } else {
          // Fermé: le bouton revient sur la ligne principale (3 options + bouton).
          primary.appendChild(btn);
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = openLabel;
          extra.hidden = true;
        }
      });
    });

    // Bloc SEO repliable (Voir plus / Voir moins)
    var seoBlocks = container.querySelectorAll('[data-seo-collapsible]');
    seoBlocks.forEach(function (seoBlock) {
      var content = seoBlock.querySelector('[data-seo-content]');
      var btn = seoBlock.querySelector('[data-seo-toggle]');
      if (!content || !btn) return;

      // Afficher le bouton uniquement si le contenu déborde la hauteur clampée
      var shouldCollapse = content.scrollHeight > content.clientHeight + 4;
      if (!shouldCollapse) {
        btn.hidden = true;
        return;
      }

      btn.hidden = false;
      btn.addEventListener('click', function () {
        var expanded = seoBlock.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });

    // Date & livraison — panneau repliable + calendrier (Perle Lactée)
    var deliveryPanel = container.querySelector('[data-perle-delivery-panel]');
    if (deliveryPanel) {
      var leadDays = parseInt(deliveryPanel.getAttribute('data-lead-days') || '30', 10);
      if (isNaN(leadDays) || leadDays < 0) leadDays = 30;

      function stripTime(d) {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
      }

      var today = stripTime(new Date());
      var minDate = stripTime(new Date(today));
      minDate.setDate(minDate.getDate() + 7);

      var toggle = deliveryPanel.querySelector('[data-perle-delivery-toggle]');
      var body = deliveryPanel.querySelector('[data-perle-delivery-body]');
      if (toggle && body) {
        toggle.addEventListener('click', function () {
          var collapsed = deliveryPanel.classList.toggle('is-collapsed');
          var open = !collapsed;
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) body.removeAttribute('hidden');
          else body.setAttribute('hidden', 'hidden');
        });
        if (deliveryPanel.classList.contains('is-collapsed')) {
          toggle.setAttribute('aria-expanded', 'false');
          body.setAttribute('hidden', 'hidden');
        } else {
          toggle.setAttribute('aria-expanded', 'true');
          body.removeAttribute('hidden');
        }
      }

      var gridEl = deliveryPanel.querySelector('[data-perle-calendar-grid]');
      var monthLabel = deliveryPanel.querySelector('[data-perle-calendar-month]');
      var calPrevBtn = deliveryPanel.querySelector('[data-perle-calendar-prev]');
      var calNextBtn = deliveryPanel.querySelector('[data-perle-calendar-next]');
      var hiddenDate = deliveryPanel.querySelector('[data-delivery-date]');

      if (gridEl && monthLabel && calPrevBtn && calNextBtn && hiddenDate) {
        var monthNamesFr = [
          'Janvier',
          'Février',
          'Mars',
          'Avril',
          'Mai',
          'Juin',
          'Juillet',
          'Août',
          'Septembre',
          'Octobre',
          'Novembre',
          'Décembre',
        ];

        var allowedMonths = (deliveryPanel.getAttribute('data-delivery-months') || '')
          .split(',')
          .map(function (part) { return parseInt(part, 10) - 1; })
          .filter(function (monthIndex) { return monthIndex >= 0 && monthIndex <= 11; });

        function monthIsAllowed(date) {
          if (!allowedMonths.length) return true;
          return allowedMonths.indexOf(date.getMonth()) !== -1;
        }

        function isSelectable(date) {
          var day = stripTime(date);
          return day >= minDate && day.getDay() !== 6 && monthIsAllowed(day);
        }

        function firstSelectableOnOrAfter(from) {
          var cursor = stripTime(new Date(from));
          for (var step = 0; step < 800; step++) {
            if (isSelectable(cursor)) return stripTime(new Date(cursor));
            cursor.setDate(cursor.getDate() + 1);
          }
          return stripTime(new Date(from));
        }

        var selected = firstSelectableOnOrAfter(minDate);
        var view = new Date(selected.getFullYear(), selected.getMonth(), 1);

        function sameDay(a, b) {
          return (
            a.getFullYear() === b.getFullYear() &&
            a.getMonth() === b.getMonth() &&
            a.getDate() === b.getDate()
          );
        }

        function toIso(d) {
          var y = d.getFullYear();
          var m = String(d.getMonth() + 1).padStart(2, '0');
          var da = String(d.getDate()).padStart(2, '0');
          return y + '-' + m + '-' + da;
        }

        function lastDateOfMonth(y, m0) {
          return new Date(y, m0 + 1, 0).getDate();
        }

        function mondayIndex(d) {
          return (d.getDay() + 6) % 7;
        }

        function monthHasSelectableDay(year, monthIndex) {
          var days = lastDateOfMonth(year, monthIndex);
          for (var day = 1; day <= days; day++) {
            if (isSelectable(new Date(year, monthIndex, day))) return true;
          }
          return false;
        }

        function adjacentSelectableMonth(dir) {
          var year = view.getFullYear();
          var monthIndex = view.getMonth();
          for (var step = 0; step < 24; step++) {
            monthIndex += dir;
            if (monthIndex > 11) {
              monthIndex = 0;
              year += 1;
            } else if (monthIndex < 0) {
              monthIndex = 11;
              year -= 1;
            }
            if (monthHasSelectableDay(year, monthIndex)) return new Date(year, monthIndex, 1);
          }
          return null;
        }

        function updateNavState() {
          var prevOk = !!adjacentSelectableMonth(-1);
          var nextOk = !!adjacentSelectableMonth(1);
          calPrevBtn.disabled = !prevOk;
          calPrevBtn.classList.toggle('is-disabled', !prevOk);
          calNextBtn.disabled = !nextOk;
          calNextBtn.classList.toggle('is-disabled', !nextOk);
        }

        function render() {
          monthLabel.textContent = monthNamesFr[view.getMonth()] + ' ' + view.getFullYear();
          gridEl.innerHTML = '';

          var y = view.getFullYear();
          var m = view.getMonth();
          var first = new Date(y, m, 1);
          var startPad = mondayIndex(first);
          var daysInMonth = lastDateOfMonth(y, m);

          for (var i = 0; i < 42; i++) {
            var dayOffset = i - startPad + 1;
            var cellDate;
            var isMuted = false;

            if (dayOffset < 1) {
              cellDate = new Date(y, m, dayOffset);
              isMuted = true;
            } else if (dayOffset > daysInMonth) {
              cellDate = new Date(y, m, dayOffset);
              isMuted = true;
            } else {
              cellDate = new Date(y, m, dayOffset);
            }

            var dOnly = stripTime(cellDate);
            var cell = document.createElement('button');
            cell.type = 'button';
            cell.className = 'romance-pure__delivery-cal-day';
            if (isMuted) cell.classList.add('is-muted');
            if (!isSelectable(dOnly)) {
              cell.classList.add('is-disabled');
              cell.disabled = true;
            }
            if (!isMuted && sameDay(dOnly, selected)) cell.classList.add('is-selected');
            cell.textContent = String(cellDate.getDate());
            var iso = toIso(dOnly);
            cell.setAttribute('data-iso', iso);

            if (!cell.disabled) {
              cell.addEventListener('click', function () {
                var picked = this.getAttribute('data-iso');
                selected = stripTime(new Date(picked + 'T00:00:00'));
                hiddenDate.value = picked;
                render();
              });
            }

            gridEl.appendChild(cell);
          }

          hiddenDate.value = toIso(selected);
          updateNavState();
        }

        calPrevBtn.addEventListener('click', function () {
          var target = adjacentSelectableMonth(-1);
          if (!target) return;
          view = target;
          render();
        });

        calNextBtn.addEventListener('click', function () {
          var target = adjacentSelectableMonth(1);
          if (!target) return;
          view = target;
          render();
        });

        render();
      }
    }

    // Sélections (taille / fleurs / matériel) + recalcul du prix + panier
    var priceEl = container.querySelector('.romance-pure__price');
    var addToCartBtn =
      container.querySelector('[data-perle-add-to-cart]') || container.querySelector('.romance-pure__button');
    wirePerleLacteeAddToCart(container, addToCartBtn);
    var stickyAddToCartBtn = addToCartBtn ? setupMobileStickyCart(container, addToCartBtn.closest('.romance-pure__button-wrap'), addToCartBtn) : null;

    if (!addToCartBtn) {
      syncAccordionsToSelectedSize();
      return;
    }

    var priceSuffix = priceEl ? priceEl.dataset.priceSuffix || '' : '';
    var basePriceValue = priceEl ? parseMoney(priceEl.dataset.priceValue) : 0;

    // Libellé "bouton" après le tiret, sinon on prend le texte complet
    var rawBtnText = addToCartBtn.textContent.trim();
    var labelPart = rawBtnText;
    if (rawBtnText.indexOf('-') !== -1) {
      labelPart = rawBtnText.split('-').slice(1).join('-').trim();
    }

    var state = {
      sizeTotal: basePriceValue,
      flowerInc: 0,
      materialInc: 0,
    };

    function updatePriceAndButton() {
      var packTotal = state.sizeTotal;
      var cartTotal = packTotal + state.flowerInc + state.materialInc;

      if (priceEl) {
        var packFormatted = formatAmount(packTotal);
        priceEl.textContent = joinFormattedAmountAndSuffix(packFormatted, priceSuffix);
      }
      if (addToCartBtn) {
        var cartFormatted = formatAmount(cartTotal);
        var cartDisplay = joinFormattedAmountAndSuffix(cartFormatted, priceSuffix);
        addToCartBtn.textContent = cartDisplay + ' - ' + labelPart;
      if (stickyAddToCartBtn) stickyAddToCartBtn.textContent = addToCartBtn.textContent;
      }
    }

    // Taille (1 sélection)
    var sizeButtons = container.querySelectorAll('.romance-pure__size-option[data-size-total]');
    if (sizeButtons.length > 0) {
      sizeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeButtons.forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          state.sizeTotal = parseMoney(btn.dataset.sizeTotal);
          updatePriceAndButton();
          syncAccordionsToSelectedSize();
        });
      });

      // Par défaut : première taille sélectionnée ; le total part du « Prix (affiché) » si renseigné, sinon du prix du bloc taille
      sizeButtons.forEach(function (b, idx) {
        if (idx === 0) {
          b.classList.add('is-selected');
          b.setAttribute('aria-pressed', 'true');
          var blockTotal = parseMoney(b.dataset.sizeTotal);
          state.sizeTotal = basePriceValue > 0 ? basePriceValue : blockTotal;
        }
      });
      updatePriceAndButton();
      syncAccordionsToSelectedSize();
    } else {
      updatePriceAndButton();
      syncAccordionsToSelectedSize();
    }

    // Fleurs (sélection multiple, comme « Fréquemment acheté ensemble »)
    var flowerButtons = container.querySelectorAll(
      '.romance-pure__option-card[data-kit-option="flower"][data-option-increment]'
    );

    function ensureFlowerQtyWidget(btn) {
      if (!btn || btn.querySelector('[data-flower-qty]')) return;
      if (!addonCardSupportsQty(btn)) return;

      var meta = btn.querySelector('.romance-pure__option-meta');
      if (!meta) return;

      var qMin = 1;
      var qMax = 99;

      var wrap = document.createElement('div');
      wrap.className = 'romance-pure__option-qty';
      wrap.setAttribute('data-flower-qty', '');
      wrap.hidden = true;

      var widget = document.createElement('div');
      widget.className = 'romance-pure__qty-widget';

      var minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'romance-pure__qty-btn';
      minus.setAttribute('data-flower-qty-minus', '');
      minus.setAttribute('aria-label', 'Diminuer la quantité');
      minus.textContent = '−';

      var input = document.createElement('input');
      input.type = 'number';
      input.className = 'romance-pure__qty-input';
      input.setAttribute('data-flower-qty-input', '');
      input.min = String(qMin);
      input.max = String(qMax);
      input.value = '1';
      input.setAttribute('aria-label', 'Quantité');

      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'romance-pure__qty-btn';
      plus.setAttribute('data-flower-qty-plus', '');
      plus.setAttribute('aria-label', 'Augmenter la quantité');
      plus.textContent = '+';

      function clampQty() {
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = qMin;
        if (v < qMin) v = qMin;
        if (v > qMax) v = qMax;
        input.value = String(v);
      }

      function stopPropagation(e) {
        e.stopPropagation();
      }

      minus.addEventListener('click', function (e) {
        stopPropagation(e);
        input.value = String((parseInt(input.value, 10) || qMin) - 1);
        clampQty();
        recalcFlowerInc();
        updatePriceAndButton();
      });
      plus.addEventListener('click', function (e) {
        stopPropagation(e);
        input.value = String((parseInt(input.value, 10) || qMin) + 1);
        clampQty();
        recalcFlowerInc();
        updatePriceAndButton();
      });
      input.addEventListener('click', stopPropagation);
      input.addEventListener('change', function () {
        clampQty();
        recalcFlowerInc();
        updatePriceAndButton();
      });
      input.addEventListener('blur', clampQty);

      widget.appendChild(minus);
      widget.appendChild(input);
      widget.appendChild(plus);

      var qtyLabel = document.createElement('span');
      qtyLabel.className = 'romance-pure__option-qty-label';
      qtyLabel.textContent = 'Quantité';
      wrap.appendChild(qtyLabel);
      wrap.appendChild(widget);

      var openLink = meta.querySelector('.romance-pure__option-open-link');
      if (openLink) meta.insertBefore(wrap, openLink);
      else meta.appendChild(wrap);
    }

    function updateFlowerQtyVisibility(btn) {
      var wrap = btn.querySelector('[data-flower-qty]');
      if (!wrap) return;
      wrap.hidden = !btn.classList.contains('is-selected');
    }

    function recalcFlowerInc() {
      var total = 0;
      flowerButtons.forEach(function (b) {
        if (!b.classList.contains('is-selected')) return;
        total += getAddonLineUnitPrice(b) * getAddonLineQty(b, 'data-flower-qty-input');
      });
      state.flowerInc = total;
    }

    if (flowerButtons.length > 0) {
      flowerButtons.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          var linkTrigger =
            event.target && event.target.closest ? event.target.closest('[data-option-open-link]') : null;
          if (linkTrigger) {
            var optionCard = linkTrigger.closest('[data-kit-option]');
            var productHandle = (
              linkTrigger.getAttribute('data-product-handle') ||
              (optionCard ? optionCard.getAttribute('data-product-handle') : '') ||
              ''
            ).trim();
            var linkUrl = (linkTrigger.getAttribute('data-option-link') || '').trim();
            if (productHandle) {
              linkUrl = '/products/' + productHandle;
            } else if (linkUrl.indexOf('/pages/') === 0) {
              var pageHandle = linkUrl.split('/pages/').pop().split('?')[0].split('#')[0];
              if (pageHandle.indexOf('decoration-chaise-') === 0) {
                pageHandle = pageHandle.replace('decoration-chaise-', 'decoration-de-chaise-');
              }
              linkUrl = '/products/' + pageHandle;
            }
            if (linkUrl) window.open(linkUrl, '_blank', 'noopener');
            return;
          }
          if (event.target && event.target.closest && event.target.closest('[data-flower-qty]')) return;

          ensureFlowerQtyWidget(btn);
          var isSelected = btn.classList.contains('is-selected');
          btn.classList.toggle('is-selected', !isSelected);
          btn.setAttribute('aria-pressed', isSelected ? 'false' : 'true');
          updateFlowerQtyVisibility(btn);
          recalcFlowerInc();
          updatePriceAndButton();
        });
      });
    }

    // Matériel (sélection multiple, comme les fleurs)
    var materialButtons = container.querySelectorAll(
      '.romance-pure__option-card[data-kit-option="material"][data-option-increment]'
    );

    function ensureMaterialQtyWidget(btn) {
      if (!btn || btn.querySelector('[data-material-qty]')) return;
      if (!addonCardSupportsQty(btn)) return;

      var meta = btn.querySelector('.romance-pure__option-meta');
      if (!meta) return;

      var qMin = 1;
      var qMax = 99;

      var wrap = document.createElement('div');
      wrap.className = 'romance-pure__option-qty';
      wrap.setAttribute('data-material-qty', '');
      wrap.hidden = true;

      var widget = document.createElement('div');
      widget.className = 'romance-pure__qty-widget';

      var minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'romance-pure__qty-btn';
      minus.setAttribute('data-material-qty-minus', '');
      minus.setAttribute('aria-label', 'Diminuer la quantité');
      minus.textContent = '−';

      var input = document.createElement('input');
      input.type = 'number';
      input.className = 'romance-pure__qty-input';
      input.setAttribute('data-material-qty-input', '');
      input.min = String(qMin);
      input.max = String(qMax);
      input.value = '1';
      input.setAttribute('aria-label', 'Quantité');

      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'romance-pure__qty-btn';
      plus.setAttribute('data-material-qty-plus', '');
      plus.setAttribute('aria-label', 'Augmenter la quantité');
      plus.textContent = '+';

      function clampQty() {
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = qMin;
        if (v < qMin) v = qMin;
        if (v > qMax) v = qMax;
        input.value = String(v);
      }

      function stopPropagation(e) {
        e.stopPropagation();
      }

      minus.addEventListener('click', function (e) {
        stopPropagation(e);
        input.value = String((parseInt(input.value, 10) || qMin) - 1);
        clampQty();
        recalcMaterialInc();
        updatePriceAndButton();
      });
      plus.addEventListener('click', function (e) {
        stopPropagation(e);
        input.value = String((parseInt(input.value, 10) || qMin) + 1);
        clampQty();
        recalcMaterialInc();
        updatePriceAndButton();
      });
      input.addEventListener('click', stopPropagation);
      input.addEventListener('change', function () {
        clampQty();
        recalcMaterialInc();
        updatePriceAndButton();
      });
      input.addEventListener('blur', clampQty);

      widget.appendChild(minus);
      widget.appendChild(input);
      widget.appendChild(plus);

      var qtyLabel = document.createElement('span');
      qtyLabel.className = 'romance-pure__option-qty-label';
      qtyLabel.textContent = 'Quantité';
      wrap.appendChild(qtyLabel);
      wrap.appendChild(widget);

      var openLink = meta.querySelector('.romance-pure__option-open-link');
      if (openLink) meta.insertBefore(wrap, openLink);
      else meta.appendChild(wrap);
    }

    function updateMaterialQtyVisibility(btn) {
      var wrap = btn.querySelector('[data-material-qty]');
      if (!wrap) return;
      wrap.hidden = !btn.classList.contains('is-selected');
    }

    function recalcMaterialInc() {
      var total = 0;
      materialButtons.forEach(function (b) {
        if (!b.classList.contains('is-selected')) return;
        total += getAddonLineUnitPrice(b) * getAddonLineQty(b, 'data-material-qty-input');
      });
      state.materialInc = total;
    }

    if (materialButtons.length > 0) {
      materialButtons.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          var linkTrigger =
            event.target && event.target.closest ? event.target.closest('[data-option-open-link]') : null;
          if (linkTrigger) {
            var optionCard = linkTrigger.closest('[data-kit-option]');
            var productHandle = (
              linkTrigger.getAttribute('data-product-handle') ||
              (optionCard ? optionCard.getAttribute('data-product-handle') : '') ||
              ''
            ).trim();
            var linkUrl = (linkTrigger.getAttribute('data-option-link') || '').trim();
            if (productHandle) {
              linkUrl = '/products/' + productHandle;
            } else if (linkUrl.indexOf('/pages/') === 0) {
              var pageHandle = linkUrl.split('/pages/').pop().split('?')[0].split('#')[0];
              if (pageHandle.indexOf('decoration-chaise-') === 0) {
                pageHandle = pageHandle.replace('decoration-chaise-', 'decoration-de-chaise-');
              }
              linkUrl = '/products/' + pageHandle;
            }
            if (linkUrl) window.open(linkUrl, '_blank', 'noopener');
            return;
          }
          if (event.target && event.target.closest && event.target.closest('[data-material-qty]')) return;

          ensureMaterialQtyWidget(btn);
          var isSelected = btn.classList.contains('is-selected');
          btn.classList.toggle('is-selected', !isSelected);
          btn.setAttribute('aria-pressed', isSelected ? 'false' : 'true');
          updateMaterialQtyVisibility(btn);
          recalcMaterialInc();
          updatePriceAndButton();
        });
      });
    }
  }

  function run() {
    var sections = document.querySelectorAll('.romance-pure');
    sections.forEach(function (section) {
      initPerleLactee(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Ré-initialiser après un changement dans le theme editor (Shopify section refresh)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.romance-pure');
    if (section) initPerleLactee(section);
  });
})();
